import React from "react";

import ContactUs from "./ContactUs";

import "./Fullstack.css";
import pythonWebPDF from "../assets/Python Web Development - Codex Future Syllabus.pdf";

const Fullstack = () => {
  return (
    <>
     

      <section className="fullstack-section">
        <div className="fullstack-container">
          <h1 className="fullstack-title">What is Full Stack Training Course?</h1>
          <h3 className="fullstack-subtitle">FullStack Website Development</h3>
          <p className="fullstack-rating">(4.8 Reviews)</p>
          <p className="fullstack-duration">Duration: 3 to 4 Months | 15+ Guaranteed Interviews</p>

          <p className="fullstack-description">
            Are you passionate about web development? Dive into the dynamic world of programming with our
            comprehensive Full Stack course. This program covers both front-end and back-end technologies,
            empowering you to build robust, full-stack web applications.
          </p>

          <button
            className="django-btn"
            onClick={() => window.open(pythonWebPDF, "_blank")}
          >
            📘 Download Syllabus
          </button>

          <h2 className="fullstack-heading">Boost Your Career with Full Stack Course in Indore</h2>
          <p className="fullstack-text">
            Become a proficient Full Stack Developer with our comprehensive course designed for aspiring web
            developers. Dive into both front-end and back-end technologies, gaining hands-on experience to
            build complete web applications. Whether you’re a beginner or looking to upskill, this course will
            equip you with the necessary tools and knowledge.
          </p>

          <h2 className="fullstack-heading">Why Choose Our Course?</h2>
          <ul className="fullstack-list">
            <li><strong>Industry-Relevant Curriculum:</strong> Learn the latest technologies and frameworks.</li>
            <li><strong>Hands-On Projects:</strong> Work on real-world applications and capstone projects.</li>
            <li><strong>Expert Instructors:</strong> Learn from experienced professionals in the field.</li>
            <li><strong>100% Placement Assistance:</strong> We support you in landing your dream job.</li>
          </ul>
        </div>
      </section>

      <ContactUs />
     
    </>
  );
};

export default Fullstack;
